// Triggers a full page reload when the main app or the widget have been updated,
// ensuring we don't serve stale assets or widget code during Unpoly navigation.
//
// After a main app deployment, the x-release response header will differ from
// window.steadyConfig.releaseVersion. The first "safe" GET root-layer Unpoly
// navigation will be re-sent as a full page load instead.
//
// After a widget deployment, up:assets:changed will detect that the inline
// widget script's version attribute changed. Because that event fires after
// `up:fragment:loaded`, the reload happens on the *next* safe GET navigation.

let widgetVersionChanged = false

function isWidgetInlineScript(asset) {
  return asset.matches('script[data-widget-version]')
}

up.on('up:assets:changed', function ({ oldAssets, newAssets }) {
  const oldWidgetInlineScript = up.util.find(oldAssets, isWidgetInlineScript)
  const newWidgetInlineScript = up.util.find(newAssets, isWidgetInlineScript)

  if (oldWidgetInlineScript === undefined && newWidgetInlineScript !== undefined) {
    document.head.append(newWidgetInlineScript)
  }

  if (oldWidgetInlineScript !== undefined && newWidgetInlineScript !== undefined) {
    const previousWidgetVersion = oldWidgetInlineScript.getAttribute('data-widget-version')
    const newWidgetVersion = newWidgetInlineScript.getAttribute('data-widget-version')

    if (previousWidgetVersion !== newWidgetVersion) {
      widgetVersionChanged = true
    }
  }
})

up.on('up:fragment:loaded', function (event) {
  const previousAssetVersion = window.steadyConfig.releaseVersion
  const fragmentAssetVersion = event.response.header('x-release')
  const steadyVersionChanged =
    previousAssetVersion && fragmentAssetVersion && previousAssetVersion !== fragmentAssetVersion

  if ((steadyVersionChanged || widgetVersionChanged) && isLoadPageSafe(event.renderOptions)) {
    event.preventDefault()
    up.network.loadPage(event.renderOptions)
  }
})

function isLoadPageSafe({ url, layer, method }) {
  const isSafeRequest = url && up.util.normalizeMethod(method) === 'GET'
  const isRootLayer = up.layer.current.isRoot() && layer !== 'new'

  return isSafeRequest && isRootLayer
}
